import { Component, Input, OnInit, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GtwElementsBaseUrlsModel } from '../../shared/_models/gtw-elements-base-urls.model';
import { ExternalLinkService } from './external-link.service';

import { safeJsonInput } from '../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-external-link',
    templateUrl: './external-link.component.html',
    styleUrls: ['./external-link.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ExternalLinkComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);


  baseURLs: GtwElementsBaseUrlsModel={
		api : '/gtw',
		custom: '/custom',
		admin: '/admin',
		efile:'/gtw-efile-api',
    pdfEngine: '/pdf-engine',
    bulkPdfEngine:'/bulk-pdf-engine'
	};

  @Input('base-urls')
	set _base_urls(baseUrls: any){
		try{
			let urls:GtwElementsBaseUrlsModel = safeJsonInput<any>(JSON.stringify(baseUrls), null, 'external-link.parse1');
			if(Object.keys(urls).length > 0){
				this.baseURLs = urls;
        this.init();
			}
		}catch(e){
			console.log("Input Not yet stable. Still waiting to get resolved.");
		}
	}

  isShowing =false;
  externalAppList:Array<{'app_name':string, 'app_url':string}>= [];


  constructor(private externalLinkService:ExternalLinkService) { }

  ngOnInit(): void {
    // this.getExternalApplications();
  }

  init(){
    this.getExternalApplications();
  }

  getExternalApplications(){
    this.externalLinkService.getExternalApplications(this.baseURLs.api).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (res) => {
        this.externalAppList = Array.isArray(res) ? res : [];
      },
      error: () => {
        this.externalAppList = [];
      },
    });
  }

  openApp(url:string){
    window.open(url, '_blank');
    this.isShowing=false;
  }

}
